<template>
  <div class="text-center my-6 lg:my-14">
    <h2
      class="text-2xl tracking-wider text-darkFont leading-10 font-bold mt-4 sm:text-2xl sm:leading-none md:text-3xl uppercase"
    >
      {{ title }}
    </h2>
    <p
      v-if="subtitle"
      class="mt-3 max-w-md mx-auto text-base font-semibold text-lightFont sm:text-lg md:mt-3 md:text-xl md:max-w-3xl"
    >
      {{ subtitle }}
    </p>

    <p
        v-if="subtitle2"
        class="mt-1 max-w-md mx-auto text-base font-semibold text-lightFont sm:text-lg md:mt-1 md:text-xl md:max-w-3xl"
    >
      {{ subtitle2 }}
    </p>
  </div>
</template>

<script>
export default {
  name: "CentralHeader",
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: false
    },
    subtitle2: {
      type: String,
      required: false
    }
  }
};
</script>

<style scoped></style>
